<template>
  <div
    class="paintingExhibition"
    v-if="this.language == 'eng'"
    style="font-family: 'Times New Roman', Times, serif"
  >
    <Pic-top></Pic-top>
    <div class="exhibitionTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">Home</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="exhibition">Regong Works Exhibition</router-link>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">{{ eng_typeName }}</span>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInRight"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="section">
      <div class="waterfallBox hidden-xs-only">
        <water-fall-base
          :data="cardList"
          v-if="cardList.length !== 0"
        ></water-fall-base>
        <div class="noMessage" v-if="cardList.length == 0 && !loading">none</div>
      </div>
      <div class="waterfallBox hidden-sm-and-up">
        <water-fall-mobile-base
          :data="cardListMobile"
          v-if="cardListMobile.length !== 0"
        ></water-fall-mobile-base>
        <div class="noMessage" v-if="cardListMobile.length == 0 && !loading">none</div>
      </div>
      <div
        class="loading"
        v-loading="loading"
        element-loading-text="loading"
        element-loading-spinner="el-icon-loading"
      ></div>
    </div>
  </div>
  <div class="paintingExhibition" v-else-if="this.language == 'en'">
    <Pic-top></Pic-top>
    <div class="exhibitionTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">ངོ་བྱང་།</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="exhibition"
            >རེབ་གོང་བརྩམས་ཆོས་འགྲེམ་སྤེལ།</router-link
          >
          <span>&nbsp;>&nbsp;</span>
          <span class="color">{{ za_typeName }}</span>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInRight"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="section">
      <div class="waterfallBox hidden-xs-only">
        <water-fall-base
          :data="cardList"
          v-if="cardList.length !== 0"
        ></water-fall-base>
        <div class="noMessage" v-if="cardList.length == 0 && !loading">
          གནས་སྐབས་གཞི་གྲངས་མེད་པ་
        </div>
      </div>
      <div class="waterfallBox hidden-sm-and-up">
        <water-fall-mobile-base
          :data="cardListMobile"
          v-if="cardListMobile.length !== 0"
        ></water-fall-mobile-base>
        <div class="noMessage" v-if="cardListMobile.length == 0 && !loading">
          གནས་སྐབས་གཞི་གྲངས་མེད་པ་
        </div>
      </div>
      <div
        class="loading"
        v-loading="loading"
        element-loading-text="གཞི་གྲངས་སྣོན་འཇུག་ཁྲོད་"
        element-loading-spinner="el-icon-loading"
      ></div>
    </div>
  </div>
  <div class="paintingExhibition" v-else>
    <Pic-top></Pic-top>
    <div class="exhibitionTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">首页1</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="exhibition">热贡作品展</router-link>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">{{ typeName }}</span>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInRight"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="section">
      <div class="waterfallBox hidden-xs-only">
        <water-fall-base
          :data="cardList"
          v-if="cardList.length !== 0"
        ></water-fall-base>
        <div class="noMessage" v-if="cardList.length == 0&& !loading">暂无数据</div>
      </div>
      <div class="waterfallBox hidden-sm-and-up">
        <water-fall-mobile-base
          :data="cardListMobile"
          v-if="cardListMobile.length !== 0"
        ></water-fall-mobile-base>
        <div class="noMessage" v-if="cardListMobile.length == 0 && !loading">暂无数据</div>
      </div>
      <div
        class="loading"
        v-loading="loading"
        element-loading-text="数据加载中"
        element-loading-spinner="el-icon-loading"
      ></div>
    </div>
  </div>
</template>
<script>
import { productPage } from "../../api/management";
import PicTop from "../../components/picsTop.vue";
import waterFallBase from "../../components/waterFallBaseWork.vue";
import waterFallMobileBase from "../../components/waterFallMobileBaseWork";
import { throttle } from 'lodash'
export default {
  components: {
    waterFallBase,
    PicTop,
    waterFallMobileBase,
  },
  data() {
    return {
      total: null,
      language: this.$store.state.language,
      queryInfo: {
        current: 1,
        pageSize: 9,
        category: this.$route.query.category,
        displaySeen: true,
      },
      mobileTotal: null,
      Info: {
        current: 1,
        pageSize: 6,
        category: this.$route.query.category,
        displaySeen: true,
      },
      typeName: "",
      za_typeName: "",
      eng_typeName: "",
      cardList: [],
      cardListMobile: [],
      loading: false,
      isLoading:false,
    };
  },
  computed: {
    changeLanguage() {
      return this.$store.state.language;
    },
  },
  watch: {
    changeLanguage: function (val) {
      this.language = val;
    },
  },
  mounted() {
    new this.$wow.WOW().init();
    this.getPCorMobile();
  },
  methods: {
    getPCorMobile() {
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.getMobileProductPage();
        window.addEventListener("scroll", this.Scrollbottom, true);
      } else {
        this.getProductPage();
        window.addEventListener("scroll", this.PCscrollBottom, true);
      }
    },
    async getProductPage() {
      console.log(111);
      this.loading = true;
      let category = this.queryInfo.category;
      if(category) {
        if (category == 1) {
          this.typeName = "唐卡";
          this.za_typeName = " ཐང་ག ";
          this.eng_typeName = "Thangka";
        } else if (category == 2) {
          this.typeName = "泥塑";
          this.eng_typeName = "Clay sculpture";
          this.za_typeName = " འཇིམ་བཟོ།";
        } else if (category == 3) {
          this.typeName = "壁画";
          this.eng_typeName = "Mural";
          this.za_typeName = "ལྡེབས་རིས། ";
        } else if (category == 4) {
          this.typeName = "堆绣";
          this.eng_typeName = "Pile embroidery";
          this.za_typeName = " དྲས་དྲུབ། ";
        } else if (category == 5) {
          this.typeName = "彩绘";
          this.eng_typeName = "Paintings";
          this.za_typeName = " ཚོན་རིས། ";
        } else if (category == 6) {
          this.typeName = "其他";
          this.eng_typeName = "Other";
          this.za_typeName = " གཞན་དག ";
        }
      } else {
        this.typeName = "全部";
        this.eng_typeName = "All";
        this.za_typeName = " ཡོངས་རྫོགས། ";
      }
      const res = await productPage(this.queryInfo);
      if (res.code == 1) {
        this.isLoading = false
        this.loading = false
        this.cardList = this.cardList.concat(res.data.records);
        this.total = res.data.total;
      }
    },
    PCscrollBottom:throttle(function(event) {
      // 变量scrollTop为当前页面的滚动条纵坐标位置
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 变量 windowHeight 是可视区的高度
      let windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      // 变量 scrollHeight 是滚动条的总高度
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      // 到底的条件
      if (scrollTop + windowHeight == scrollHeight) {
        if(this.isLoading) {
          if (this.queryInfo.current * 9 >= this.total) {
            this.isLoading = false
            console.log(1111);
            return this.$message("数据加载完毕");
          }
          this.loading = true;
          this.queryInfo.current++;
          this.getProductPage();
        }
      } else {
        this.isLoading = true
      }
    },1000),
    Scrollbottom:throttle(function(event) {
      // 变量scrollTop为当前页面的滚动条纵坐标位置
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 变量 windowHeight 是可视区的高度
      let windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      // 变量 scrollHeight 是滚动条的总高度
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      // 到底的条件
      if (scrollTop + windowHeight + 100 >= scrollHeight) {
        if(this.isLoading) {
          if (this.Info.current * 6 >= this.mobileTotal) {
            this.isLoading = false
            return this.$message("数据加载完毕");
          }
          this.loading = true;
          this.Info.current += 1;
          this.getMobileProductPage();
        }
      } else {
        this.isLoading = true
      }
    },2000),
    async getMobileProductPage() {
      this.loading = true;
      let category = this.queryInfo.category;
      if (category == 1) {
        this.typeName = "唐卡";
        this.za_typeName = "  ཐང་ག ";
        this.eng_typeName = "Thangka";
      } else if (category == 2) {
        this.typeName = "泥塑";
        this.eng_typeName = "Clay sculpture";
        this.za_typeName = "འཇིམ་བཟོ། ";
      } else if (category == 3) {
        this.typeName = "壁画";
        this.eng_typeName = "Mural";
        this.za_typeName = "ལྡེབས་རིས།";
      } else if (category == 4) {
        this.typeName = "堆绣";
        this.eng_typeName = "Pile embroidery";
        this.za_typeName = " དྲས་དྲུབ། ";
      } else if (category == 5) {
        this.typeName = "彩绘";
        this.eng_typeName = "Paintings";
        this.za_typeName = "ཚོན་རིས། ";
      } else if (category == 6) {
        this.typeName = "其他";
        this.eng_typeName = "Other";
        this.za_typeName = " གཞན་དག ";
      }
      const res = await productPage(this.Info);
      if (res.code == 1) {
        this.isLoading = false
        this.loading = false
        this.cardListMobile = this.cardListMobile.concat(res.data.records);
        this.mobileTotal = res.data.total;
      }
    },
    handleRouter(num) {
      this.$store.commit("changeNum", num);
      this.$router.push("/index");
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.PCscrollBottom, true);
    window.removeEventListener("scroll", this.Scrollbottom, true);
  },
};
</script>
<style lang="scss">
.paintingExhibition {
  background: url("../../assets/newImage/index/could_right.png") no-repeat right
    bottom;
  background-position: 100% 100%;
  background-size: 7%;
  .image {
    position: relative;
    background: url("../../assets/newImageBgc/newImage_1.png") no-repeat center
      center;
    background-size: 100% 100%;
    height: 580px;
    .text {
      text-align: center;
      width: 2.5rem;
      position: absolute;
      top: 50%;
      right: 0;
      transform: translate(0, -50%);
      color: #fff;
      font-size: 82px;
      font-family: "fangzang";
    }
    .za_text {
      font-size: 52px;
    }
    .eng_text {
      font-family: "Times New Roman", Times, serif;
      font-size: 78px;
    }
  }
  .exhibitionTop {
    border-bottom: 1px solid #f4f5f6;
    position: relative;
    .section {
      padding: 50px 0;
      font-size: 18px;
      position: relative;
      .section_left {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        z-index: 88;
        .color {
          color: #ed201a;
        }
        span {
          cursor: pointer;
        }
      }
    }
    .cloudLeft {
      position: absolute;
      top: 50%;
      left: 0;
      z-index: 1;
      width: 125px;
      height: 95px;
    }
  }
  .section {
    .waterfallBox {
      .noMessage {
        margin: 20px 0;
        letter-spacing: 4px;
        font-weight: bold;
        font-size: 24px;
        text-align: center;
      }
    }
    .loading {
      margin-bottom: 20px;
      .el-loading-mask {
        .el-loading-spinner {
          .el-icon-loading {
            color: #ef3731;
          }
          .el-loading-text {
            color: #ef3731;
          }
        }
      }
    }
  }
}
@media (max-width: 768px) {
  .paintingExhibition {
    background-size: 15%;
    padding-bottom: 1rem;
    position: relative;
    .image {
      background: url("../../assets/newImageBgc/mobile_newImage_1.jpg")
        no-repeat center center;
      background-size: cover;
      height: 3.4rem;
      position: relative;
      .text {
        font-size: 0.5rem !important;
      }
    }
    .exhibitionTop {
      .section {
        background: url("../../assets/newImage/index/could_left.png") no-repeat
          top left;
        background-position: 0 50%;
        background-size: 15%;
        padding: 0.6rem 0.2rem;
        font-size: 0.3rem;
        .section_left {
          left: 0.2rem;
        }
        span {
          cursor: pointer;
        }
      }
      .moblieCloudLeft {
        position: absolute;
        top: 6%;
        right: 0;
        width: 1.25rem;
      }
    }
    .cloudright {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 1.25rem;
    }
    .section {
      .waterfallBox {
        .noMessage {
          font-weight: bold;
          font-size: 0.3rem;
          text-align: center;
        }
      }
    }
  }
}
</style>
